<mat-chip
    [disabled]="!isMostRecentFilter && addedFilterLength > 1"
    [ngClass]="{ disabled: !isMostRecentFilter && addedFilterLength > 1 }"
    #menuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="selectionMenu">
    <mat-icon class="remove_filter_icon" matChipRemove (click)="removeFilter()"
        >cancel
    </mat-icon>
    <div class="normal_text">
        <ng-container *ngIf="selectedOption; else defaultLabel">
            {{ selectedOption.heading }}
        </ng-container>
        <ng-template #defaultLabel>
            {{ filter.name }}
        </ng-template>
    </div>
    <mat-icon class="toolbar_icon_colour"> arrow_drop_down </mat-icon>
</mat-chip>

<mat-menu #selectionMenu="matMenu" #matMenu="matMenu" class="user_menu">
    <div [ngSwitch]="filter.filterOptionType">
        <ng-container *ngSwitchCase="dataTypeEnum.HeadingOnly">
            <button
                *ngFor="let option of filter.options"
                mat-menu-item
                (click)="selectOption(option)">
                {{ option.heading }}
            </button>
            <button *ngIf="!filter.options.length" mat-menu-item disabled>
                No options available
            </button>
        </ng-container>
    </div>
</mat-menu>
